// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1gz0L","footer":"ModalUpdate_footer__24WOy"};